export default __webpack_public_path__ + "static/media/Icon metro-twitter.77f09fdf.svg";